import { render, staticRenderFns } from "./allPeas.vue?vue&type=template&id=6a91d3e0&scoped=true"
import script from "./allPeas.vue?vue&type=script&lang=js"
export * from "./allPeas.vue?vue&type=script&lang=js"
import style0 from "./allPeas.vue?vue&type=style&index=0&id=6a91d3e0&prod&scoped=true&lang=css"
import style1 from "./allPeas.vue?vue&type=style&index=1&id=6a91d3e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a91d3e0",
  null
  
)

export default component.exports